export default __webpack_public_path__ + "static/media/p2.194f72b1.jpeg";